import React, { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAppSelector } from '../../store/hooks';

const Navbar: FC = () => {
  const { pathname } = useLocation();
  const title = useMemo(() => {
    const paths = pathname.split('/');
    return paths.length === 2
      ? paths[1]
      : paths.length === 0
      ? 'Dashboard'
      : paths[2];
  }, [pathname]);
  const auth = useAppSelector((state) => state.auth);
  return (
    <>
      <NavbarContainer>
        <NavbarBody>
          <NavbarTitle>{title.replaceAll('-', ' ')}</NavbarTitle>
          <NavbarProfileContainer>
            <NavbarProfileImage
              src={
                auth?.user?.avatar?.url ||
                'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_1280.png'
              }
              alt=""
            />
            {/* <NavbarNotification src={notificationBell} alt="" /> */}
          </NavbarProfileContainer>
        </NavbarBody>
      </NavbarContainer>
    </>
  );
};

export default Navbar;

const NavbarContainer = styled.section`
  width: 100%;
  background-color: transparent;
  padding: 10px 1px;
`;
const NavbarBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavbarTitle = styled.h1`
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  text-transform: capitalize;
`;

const NavbarProfileContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0.08;
`;
const NavbarProfileImage = styled.img`
  margin-right: 28.67px;
  height: 32px;
  width: 32px;
  object-fit: cover;
  border-radius: 16px;
`;
